import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mascotSettings: null,
  promotionOffer: null,
  promotionOfferFetched: false,
  privacyPolicyDisclaimer: {
    title: "",
    message: "",
    message_es: "",
    isEnabled: false,
  },
};

export const mascotSettingSlice = createSlice({
  name: "mascotSetting",
  initialState,
  reducers: {
    setMascotSettings: (state, action) => {
      state.mascotSettings = action.payload;
    },
    setPromotionOffer: (state, action) => {
      state.promotionOffer = action.payload;
      state.promotionOfferFetched = true;
    },
    setPrivacyPolicyDisclaimer: (state, action) => {
      state.privacyPolicyDisclaimer = action.payload;
    },
  },
});

export const selectMascotSettings = (state) => state.mascotSetting.mascotSettings;
export const selectPromotionOffer = (state) => state.mascotSetting.promotionOffer;
export const selectPromotionOfferFetched = (state) => state.mascotSetting.promotionOfferFetched;
export const selectPrivacyPolicyDisclaimer = (state) => state.mascotSetting.privacyPolicyDisclaimer;
export const { setMascotSettings, setPromotionOffer, setPrivacyPolicyDisclaimer, setDisclaimerEnabled } = mascotSettingSlice.actions;

export default mascotSettingSlice.reducer;
